// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/icing-conditions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/icing-conditions/icing-along-route-605-30.js';
import g1 from '../lessons/air-law/icing-conditions/icing-conditions.js';

mount([g0, g1]);
